module.exports = __webpack_public_path__ + "img/header-img.9a1fd5d3.png";